module.exports = __webpack_public_path__ + "static/media/conan-yr-bg.fb658e93.jpg";